import React from 'react'
import styled from 'styled-components'

import HeroUnit from 'components/investor/hero-unit'
import About from 'components/investor/about'
import Presentation from 'components/investor/presentation'
import GetStarted from 'components/get-started'

const InvestorStyle = styled.div``

export default class Investor extends React.Component {
  render () {
    const { heroUnit, about, presentation, getStarted } = this.props
    return (
      <InvestorStyle>
        <HeroUnit data={heroUnit} />
        <About data={about} />
        <Presentation data={presentation} />
        <GetStarted isInternal data={getStarted} />
      </InvestorStyle>
    )
  }
}
